export interface IDataState {
  data: any;
  page: unknown;
  location: unknown
}

export default {
  data: '',
  page: null,
  location: null,
} as IDataState;
